<template>
  <div class="osk-field-row">
    <slot />
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-field-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  & + &,
  & + .osk-field,
  & + .osk-button {
    margin-top: $indent-compact;
  }

  .osk-field {
    width: 100%;
    margin-top: 0;
  }

  .osk-field + .osk-field {
    margin-left: $indent-compact;
  }
}
</style>
